import React from "react";
import { motion } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";
import "../App.css";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.cursorRef = React.createRef();
    this.cursorDotRef = React.createRef();
  }

  componentDidMount = () => {
    const cursor = this.cursorRef.current;
    const cursorDot = this.cursorDotRef.current;
    
    if (cursor && window.innerWidth > 768) {
      let mouseX = 0;
      let mouseY = 0;
      let cursorX = 0;
      let cursorY = 0;

      const updateCursor = () => {
        cursorX += (mouseX - cursorX) * 0.1;
        cursorY += (mouseY - cursorY) * 0.1;
        
        cursor.style.left = cursorX + "px";
        cursor.style.top = cursorY + "px";
        
        if (cursorDot) {
          cursorDot.style.left = mouseX + "px";
          cursorDot.style.top = mouseY + "px";
        }
        
        requestAnimationFrame(updateCursor);
      };

      const handleMouseMove = (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
      };

      const handleMouseDown = () => {
        cursor.style.transform = "translate(-50%, -50%) scale(0.8)";
        if (cursorDot) {
          cursorDot.style.transform = "translate(-50%, -50%) scale(1.5)";
        }
      };

      const handleMouseUp = () => {
        cursor.style.transform = "translate(-50%, -50%) scale(1)";
        if (cursorDot) {
          cursorDot.style.transform = "translate(-50%, -50%) scale(1)";
        }
      };

      const handleMouseEnter = () => {
        cursor.style.transform = "translate(-50%, -50%) scale(1.5)";
        cursor.style.background = "linear-gradient(45deg, #3b82f6, #8b5cf6, #ec4899)";
      };

      const handleMouseLeave = () => {
        cursor.style.transform = "translate(-50%, -50%) scale(1)";
        cursor.style.background = "linear-gradient(45deg, #3b82f6, #8b5cf6)";
      };

      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mousedown", handleMouseDown);
      window.addEventListener("mouseup", handleMouseUp);

      // Add hover effects to interactive elements
      const interactiveElements = document.querySelectorAll('a, button, [role="button"], input, textarea');
      interactiveElements.forEach(el => {
        el.addEventListener('mouseenter', handleMouseEnter);
        el.addEventListener('mouseleave', handleMouseLeave);
      });

      updateCursor();

      // Cleanup
      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mousedown", handleMouseDown);
        window.removeEventListener("mouseup", handleMouseUp);
        interactiveElements.forEach(el => {
          el.removeEventListener('mouseenter', handleMouseEnter);
          el.removeEventListener('mouseleave', handleMouseLeave);
        });
      };
    }

    // Initialize AOS with custom settings
    const options = { 
      duration: 1000,
      easing: 'ease-out-cubic',
      once: true,
      offset: 100
    };
    Aos.init(options);

    // Refresh AOS on route changes
    Aos.refresh();
  };

  render() {
    return (
      <React.Fragment>
        <div className="page relative">
          <div className="flex flex-row overflow-hidden min-h-screen">
            {this.props.children}
          </div>
          
          {/* Custom Cursor */}
          {window.innerWidth > 768 && (
            <>
              <div 
                ref={this.cursorRef}
                className="cursor fixed w-8 h-8 rounded-full pointer-events-none z-[9999] transition-transform duration-200 ease-out"
                style={{
                  background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
                  transform: 'translate(-50%, -50%)',
                  mixBlendMode: 'difference'
                }}
              />
              <div 
                ref={this.cursorDotRef}
                className="fixed w-1 h-1 bg-white rounded-full pointer-events-none z-[9998] transition-transform duration-100 ease-out"
                style={{
                  transform: 'translate(-50%, -50%)'
                }}
              />
            </>
          )}

          {/* Loading Overlay */}
          <motion.div
            className="fixed inset-0 bg-black z-[10000] flex items-center justify-center"
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{ pointerEvents: 'none' }}
          >
            <motion.div
              className="text-white text-2xl font-bold"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                <span className="gradient-text">Loading...</span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </React.Fragment>
    );
  }
}

export default Layout;